module.exports = "/_next/static/images/video_id_7096957136432958766-fcbecec7b65b17731dcaa54990890bcf.jpg";